import { render, staticRenderFns } from "./addTemplete.vue?vue&type=template&id=35c05bb9&scoped=true&"
import script from "./addTemplete.vue?vue&type=script&lang=js&"
export * from "./addTemplete.vue?vue&type=script&lang=js&"
import style0 from "./addTemplete.vue?vue&type=style&index=0&id=35c05bb9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c05bb9",
  null
  
)

export default component.exports